import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextMaskModule } from 'angular2-text-mask';
import { ManageCharterComponent } from './manage-charter.component';
import { ManageCharterResolve } from './manage-charter.resolve';
import { InvoicingModule } from '../invoicing/invoicing.module';
import { FileListModule } from '../../../shared/file-list/file-list.module';
import { NoCaptainModalComponent } from '../../../shared/modals/no-captain/no-captian-modal.component';
import { CancelCharterChickenTestComponent } from '../../../shared/modals/cancel-charter-chicken-test/cancel-charter-chicken-test.component';
import { CustomerGovIdBadgeModule } from '../../../shared/customer/customer-gov-id-badge/customer-gov-id-badge.module';
import { AsyncButtonModule } from '../../../shared/directives/async-button/async-button.module';
import { MainPipe } from '../../../shared/pipes/pipes.module';
import { MatTabsModule } from '@angular/material/tabs';
import { AddNewTransactionDialogModule } from './add-new-transaction-dialog/add-new-transaction-dialog.module';
import { ReconciliationAndPayoutModule } from './reconciliation-and-payout/reconciliation-and-payout.module';
import { SharedModule } from '../../../shared/shared.module';
import { CaptainChecklistComponent } from './captain-checklist/captain-checklist.component';
import { RefundPaymentDialogModule } from './refund-payment-dialog/refund-payment-dialog.module';
import { CreatePayoutFromPaymentDialogModule } from './create-payout-from-payment-dialog/create-payout-from-payment-dialog.module';
import { AffiliateAdminManageCharterDisplayModule } from '../../../affiliate/affiliate-admin-manage-charter-display/affiliate-admin-manage-charter-display.module';
import { ManageCharterNotesModule } from './manage-charter-notes/manage-charter-notes.module';
import { CustomerPaymentMethodStatusModule } from '../../../shared/customer/customer-payment-method-status/customer-payment-method-status.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';
import { AdminPromoCodeModule } from './admin-promo-code/admin-promo-code.module';
import { SecurityHoldPostprocessingDialogModule } from './security-hold-postprocessing-dialog/security-hold-postprocessing-dialog.module';
import { ChargeAdditionalCostsDialogModule } from './charge-additional-costs-dialog/charge-additional-costs-dialog.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ManageCustomerReviewModule } from './manage-customer-review/manage-customer-review.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule,
    FlexLayoutModule,
    TextMaskModule,
    MatDialogModule,
    MatListModule,
    MatDatepickerModule,
    InvoicingModule,
    FileListModule,
    MatExpansionModule,
    CustomerGovIdBadgeModule,
    MatIconModule,
    AsyncButtonModule,
    MainPipe,
    MatTabsModule,
    AddNewTransactionDialogModule,
    ReconciliationAndPayoutModule,
    CreatePayoutFromPaymentDialogModule,
    SharedModule,
    RefundPaymentDialogModule,
    SecurityHoldPostprocessingDialogModule,
    ChargeAdditionalCostsDialogModule,
    AffiliateAdminManageCharterDisplayModule,
    MatProgressBarModule,
    ManageCharterNotesModule,
    CustomerPaymentMethodStatusModule,
    ListGridModule,
    AdminPromoCodeModule,
    ManageCustomerReviewModule,
  ],
  declarations: [
    ManageCharterComponent,
    NoCaptainModalComponent,
    CancelCharterChickenTestComponent,
  ],
  entryComponents: [NoCaptainModalComponent, CancelCharterChickenTestComponent],
  exports: [ManageCharterComponent],
  providers: [ManageCharterResolve],
})
export class ManageCharterModule {}
